module.exports = __webpack_public_path__ + "img/youtube-logo.59ec4423.svg";